import { FC } from "preact/compat";
import { useDelay } from "../data/delay";
import { GameStatus } from "../data/status";
import { Game } from "../data/streams";
import NumberInput from "./NumberInput";
import styles from "./GamePlay.module.css";

type GamePlayProps = {
    game: Game;
    status: GameStatus;
};

const GamePlay: FC<GamePlayProps> = ({ status }) => {
    const { delay, setDelay } = useDelay();

    if (!status.lastPlayText) {
        return null;
    }

    return (
        <div className={styles.gamePlay}>
            <span className={styles.text} title={status.lastPlayText}>
                {status.lastPlayText}
            </span>
            <span className={styles.delay}>
                (delay:{" "}
                <NumberInput
                    value={delay}
                    onChange={(d) => setDelay(Math.max(0, d))}
                />
                s)
            </span>
        </div>
    );
};

export default GamePlay;
